import React from 'react';
import styled from 'styled-components';
import { Button } from '../../../Components';

interface IConfigChancePage {
  page: number;
  changePage: any;
  length: number;
  pageSize: number;

}

const Styled = styled.div`
  display: grid;
  grid-template-columns: repeat(12, 1fr);
`;

const StyledButton = styled(Button) <any>`
  grid-column: ${p => p.gridColumn};
  margin-top: 10px;
  margin-left: 5px;
  margin-right: 5px;
  margin-bottom: 2px;
`;

const ChangePage: React.FC<IConfigChancePage> = (props: IConfigChancePage) => {
  const { page, pageSize, length, changePage } = props;

  return (
    <Styled>
      {page > 1 ? (
        <StyledButton gridColumn='1/3' onClick={() => changePage(-1)}>
          Anterior
        </StyledButton>
      ) : (
          <></>
        )}
      {length == pageSize ? (
        <StyledButton gridColumn='11/13' onClick={() => changePage(1)}>
          Próximo
        </StyledButton>
      ) : (
          <></>
        )}
    </Styled>
  );
};

export default ChangePage;